/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Carrier_NewInputs */

const vi_shipping_carrier_new = /** @type {(inputs: Shipping_Carrier_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm đơn vị`)
};

/**

* @param {Shipping_Carrier_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shipping_carrier_new = /** @type {((inputs?: Shipping_Carrier_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Carrier_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shipping_carrier_new(inputs)
});